<template>
  <VerifikasiRealisasiForm mode="Edit" module="Verifikasi Realisasi Indikator Kinerja"> </VerifikasiRealisasiForm>
</template>

<script>
import VerifikasiRealisasiForm from './form-realisasi';
import { onBeforeRouteLeave } from 'vue-router';
import { useStore } from 'vuex';

const VerifikasiRealisasiUpdate = {
  name: 'VerifikasiRealisasiUpdate',
  components: { VerifikasiRealisasiForm },
  setup() {
    const store = useStore();
    onBeforeRouteLeave(() => {
      store.commit('axiosResetState');
    });
  },
};

export default VerifikasiRealisasiUpdate;
</script>
